import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from "src/components/Common/TableContainer";
import { useNavigate } from "react-router";
import ModalValidation from "../Forms/FormValidation/units/ModalValidation";
import { useSelector } from "react-redux";
import useToast from "src/components/Common/toast";

const Units = () => {
  document.title = "Listar Orgãos de Estrutura - Khozi";
  const navigate = useNavigate();
  const [modal, setModal] = useState<boolean>(false);
  const [unitList, setunitList] = useState<any>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const { show, ToastComponent } = useToast();
  const [successDelete, setSuccessDelete] = useState(false);
  const [errorDelete, setErrorDelete] = useState(false);
  const [successUpdate, setSuccessUpdate] = useState(false);
  const [errorUpdate, setErrorUpdate] = useState(false);

  useEffect(() => {
    if (errorDelete) {
      show("Erro", "Erro ao apagar o orgão de estrutura.");
      setErrorDelete(false);
    } else if (successDelete) {
      show("Sucesso", "Orgão de estrutura apagado com sucesso.");
      setSuccessDelete(false);
    } else if (errorUpdate) {
      show("Erro", "Erro ao actualizar o orgão de estrutura.");
      setErrorUpdate(false);
    } else if (successUpdate) {
      show("Sucesso", "Orgão de estrutura actualizado com sucesso.");
      setSuccessUpdate(false);
    }
  }, [successDelete, errorDelete, successUpdate, errorUpdate]);

  const units = useSelector((state: any) => state.units.units);

  const toggle = () => {
    setModal(!modal);
  };

  const handleRowClick = (arg: any) => {
    const unit = arg;
    setunitList({
      id: unit.id,
      name: unit.name,
      parent: unit.parent,
      type: unit.tipo,
    });
    setIsEdit(true);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "Nome",
        accessor: "name",
        disableFilters: true,
        filterable: true,
      },

      {
        Header: "Tipo",
        accessor: "tipo_name",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Nível",
        accessor: "tipo_level",
        disableFilters: true,
        filterable: true,
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {ToastComponent}
          <Breadcrumbs
            title="Orgãos de Estrutura"
            breadcrumbItem="Listar Orgãos de Estrutura"
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <TableContainer
                    addButtonLabel="Novo Orgão de Estrutura"
                    columns={columns}
                    data={units}
                    isGlobalFilter={true}
                    isAddUserList={true}
                    isOptionalAdd={true}
                    customPageSize={10}
                    className="custom-header-css"
                    handleUserClick={() => {
                      navigate("/units/create");
                    }}
                    handleRowClick={handleRowClick}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle} centered={true}>
            <ModalHeader toggle={toggle} tag="h4">
              Editar {unitList.name}
            </ModalHeader>
            <ModalBody>
              <ModalValidation
                selectedUnit={unitList}
                setModal={setModal}
                setSuccessDelete={setSuccessDelete}
                setErrorDelete={setErrorDelete}
                setSuccessUpdate={setSuccessUpdate}
                setErrorUpdate={setErrorUpdate}
              />
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Units;
